import React from 'react';
import { Chevron } from "../../svg";
import { chevronDirection } from "../../svg/Svg";

function BlockHeader({ title, link, iconSize = "medium", ...otherProps }) {
  return (
    <div className="d3-l-grid--outer">
      <div className="d3-l-grid--inner">
        <div className="d3-l-col__col-12">
          <div className="mls-o-block-header">
            {
              link
                ? (
                  <a {...otherProps} className="mls-o-block-header__title" href={link}>
                    {title}
                    <Chevron direction={chevronDirection.right} size={iconSize} />
                  </a>
                )
                : (
                  <div {...otherProps} className="mls-o-block-header__title">
                    {title}
                  </div>
                )
            }
          </div>
        </div>
      </div>
    </div>
  );
}

// eslint-disable-next-line no-func-assign
BlockHeader = React.memo(BlockHeader);

export default BlockHeader;
